
















  import { Vue, Component } from 'vue-property-decorator'
  import { mapGetters } from 'vuex'

  @Component({
    components: { },
    computed: mapGetters([
      'ontologies',
      'language'
    ])
  })
  export default class OntologiesLeftPane extends Vue {
    mounted () {
      console.log('OntologiesLeftPane: mounted hook')
    }
  }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/OntologiesLeftPane.vue